import React from 'react';
import { Link } from 'react-router-dom';
import Rating from './Rating';
import { formatPrice, AFFILIATE_LABELS } from '@/lib/utils';
import { SealCheck } from '@phosphor-icons/react';

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative bg-card border border-border hover:border-primary rounded-sm overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:shadow-lg flex flex-col animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
    >
      <div className="relative aspect-[4/3] bg-muted overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => { e.currentTarget.src = 'https://images.unsplash.com/photo-1555337159-d399aaa99955?auto=format&fit=crop&w=900&q=70'; }}
        />
        {product.is_best_buy && (
          <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-2 py-1 text-[10px] font-bold uppercase tracking-widest rounded-sm flex items-center gap-1" data-testid="best-buy-badge">
            <SealCheck weight="fill" size={12} /> Beste keuze
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="overline text-muted-foreground mb-1">{product.brand}</div>
        <h3 className="font-display font-bold text-base leading-tight mb-2 group-hover:text-primary transition-colors">
          {product.name}
        </h3>
        <Rating rating={product.rating} count={product.review_count} compact />
        <p className="text-sm text-muted-foreground mt-3 line-clamp-2 flex-1">{product.short_description}</p>
        <div className="mt-4 pt-4 border-t border-dashed border-border flex items-center justify-between">
          <div>
            <div className="font-display font-black text-xl">{formatPrice(product.price)}</div>
            <div className="text-[10px] overline text-muted-foreground">
              {product.affiliates.map((a) => AFFILIATE_LABELS[a.shop]).filter(Boolean).slice(0, 3).join(' · ')}
            </div>
          </div>
          <div className="text-xs font-semibold text-primary group-hover:underline">Bekijken →</div>
        </div>
      </div>
    </Link>
  );
}
